import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ScrollToTop from "./ScrollToTop";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
// axios.defaults.baseURL = "http://localhost:80/rama-kids-api";
axios.defaults.baseURL = "https://ramakrishnapublicschool.com/rama-kids";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
